import { SourceType } from "../../../../../store/ExternalEpmConnectStore";

export const CARD_SETTINGS = "cardSettings";
export const TASK_FORM_SETTINGS = "taskForm";

export type CardSettings = {
    cardName: string;
    items: string[];
};

export type ScheduleCardSettings = {
    ppmx: CardSettings[];
    vsts: CardSettings[];
    jira: CardSettings[];
    o365Planner: CardSettings[];
    spo: CardSettings[];
    mondayCom: CardSettings[];
    smartsheet: CardSettings[];
    mppFile: CardSettings[];
    p4w: CardSettings[];
};

export type TaskFormSettings = { [key in keyof ScheduleCardSettings]?: string[] };

export const sourceSettingsPropertyBySourceTypeMap: { [key in SourceType]?: keyof ScheduleCardSettings } = {
    [SourceType.Ppmx]: 'ppmx',
    [SourceType.VSTS]: 'vsts',
    [SourceType.Jira]: 'jira',
    [SourceType.O365Planner]: 'o365Planner',
    [SourceType.Spo]: 'spo',
    [SourceType.MondayCom]: 'mondayCom',
    [SourceType.Smartsheet]: 'smartsheet',
    [SourceType.MPPFile]: 'mppFile',
    [SourceType.P4W]: 'p4w',
};
